import { CreateApiResponse, FetchApiResponse } from "redux/types";

export enum StatementOfAccountsReduxTypes {
    STATEMENT_OF_ACCOUNTS_REPORT = "@@auth/STATEMENT_OF_ACCOUNTS_REPORT",
    STATEMENT_OF_ACCOUNTS_REPORT_SUCCESS = "@@auth/STATEMENT_OF_ACCOUNTS_REPORT_SUCCESS",
    STATEMENT_OF_ACCOUNTS_REPORT_ERROR = "@@auth/STATEMENT_OF_ACCOUNTS_REPORT_ERROR"
}

export type StatementOfAccountsActionDispatch = {
    type: | StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT
    payload: any;
}

export type StatementOfAccountsReducerDispatch = {
    type: | StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT
    | StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_SUCCESS
    | StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_ERROR
    payload: {
        data?: FetchApiResponse<StatementOfAccounts>
        error?: string
    }
}

export type StatementOfAccounts = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateStatementOfAccounts = {
    startDate: string,
    endDate: string,
    customerExternalId: string,
    loanAccountNumber: string,
    saveReport: boolean
}

export type CreateStatementOfAccountsRequest = {
    payload: CreateStatementOfAccounts,
    type: string
}

export type CreateStatementOfAccountsReduxState = {
    loading?: boolean,
    data?: CreateApiResponse<StatementOfAccounts>
    error?: string | null
}